import { createApp } from "vue";
import CreateShipperForm from "@js/vue/views/CreateShipperForm.vue";
import CreateExpeditionForm from "@js/vue/views/CreateExpeditionForm.vue";
import ExpeditionsIndex from "@js/vue/views/ExpeditionsIndex.vue";
import CreatePolicyForm from "./vue/views/CreatePolicyForm.vue";
import CreateStoragePolicyForm from "./vue/views/CreateStoragePolicyForm.vue";
import ClaimForm from "./vue/views/ClaimForm.vue";
import ForwarderPolicies from "./vue/views/ForwarderPolicies.vue";

//TODO: check if we can import less (dropdown)
import "bootstrap";

window.GetHooked = {};

const afterLoad = () => {
	document.querySelectorAll(".vue-wrapper").forEach((el) =>
		createApp({
			components: {
				CreateShipperForm,
				CreateExpeditionForm,
				ExpeditionsIndex,
				CreatePolicyForm,
				CreateStoragePolicyForm,
				ClaimForm,
				ForwarderPolicies
			},
		}).mount(el),
	);
};

document.addEventListener("DOMContentLoaded", afterLoad);
